import { ItemResponse, UserResponse } from "baaanggg"
import { Link } from "react-router-dom"

type Prop = {
    item: ItemResponse
}

export function PreviewItemCard({ item }: Prop) {
    return <Link to={`/item/${item.id}`}
        className="block rounded-2.5xl border border-jacarta-100 bg-white p-[1.1875rem] transition-shadow hover:shadow-lg dark:border-gray-900 dark:bg-gray-900">
        <figure className="relative">
            <img src={item.image} alt="item 4" className="w-full rounded-[0.625rem]"
                loading="lazy" />
        </figure>
        <div className="mt-4 flex items-center justify-between">
            <span className="font-display text-base text-jacarta-700 hover:text-accent dark:text-white">
                {item.name}
            </span>
        </div>
    </Link>
}